import { render, staticRenderFns } from "./MahkemeForm.vue?vue&type=template&id=6dfd2161"
import script from "./MahkemeForm.vue?vue&type=script&lang=ts"
export * from "./MahkemeForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports